export default "__VITE_ASSET__CPUVeNWF__"